export default class Blacklist {

  constructor(modelData, store) {

    if (!modelData) {
      modelData = this.getDefault()
    }

    this.set(modelData)
    this.store = store
  }

  getDefault() {
    return {
      id: null,
      type: null,
      value: null,
      category: null,
      comment: null,
      isActive: true,
      hits: 0,
      createdAt: null,
      updatedAt: null,
      createdBy: null,
      updatedBy: null
    }
  }

  set(data) {
    Object.assign(this, data)
  }

  getJSON() {
    return {
      id: this.id,
      type: this.type,
      value: this.value,
      category: this.category,
      comment: this.comment,
      isActive: this.isActive,
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/blacklist/model.js